// extracted by mini-css-extract-plugin
export default {"blocker":"BookingOverview_blocker__5lbNg","preamble":"BookingOverview_preamble__b0gAO","spin":"BookingOverview_spin__PIqVx"};